<template>
  <div class="w-100 bg-gray20 SECTION m-b-6">
    <div class="container d-flex fd-column p-y-6">
      <div class="h3 text-bold p-x-1:mo p-b-2">
        <div>{{content.title}}</div>
      </div>
      <div class="d-flex w-100 fd-column:mo p-x-1 flex-0-1" >
        <div
            v-for="(item, index) in content.items"
            :key="index"
            class="ITEM"
        >
          <div class="d-flex fd-column p-b-2">
            <div class="text-bold p-x-1:mo">
              <img
                  class="m-l-0 m-r-1 m-y-1 ITEM-IMAGE"
                  :src="item.image"
              />
              {{item.title}}
            </div>
            <p class="p-x-1:mo">{{item.description}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  name: 'value-props-section',
  computed: {
    ...mapGetters('homepage/contentful', [
      'proHomePage',
    ]),
    content () {
      return this.proHomePage.valueProps;
    },
  },
};
</script>

<style scoped lang="scss">
@import "~@homeservices/design-kit/tools";

.ITEM-IMAGE {
  max-width: 40px;
}
.ITEM {
  @include desktop () {
    margin-right: 16px;
  }
}
.ITEM:nth-child(3) {
  margin-right: 0px;
}
</style>
